<template lang="pug">
  data-handler(
    v-model="event"
    :method="getEvent"
    :serialize-data="serializeData"
    show-loading
  )
    template(v-slot:loading)
      text-loader(
        :is-init="false"
        text="..."
      )

    template(v-slot:default)
      slot(
        v-if="event"
        :event="event"
      )
</template>

<script>
import TextLoader from '@/components/user-redesign/layout/TextLoader.vue';

export default {
  components: {
    TextLoader,
  },
  data() {
    return {
      event: null,
    };
  },
  watch: {
    event(val) {
      if (!val) this.$router.push('/404');
    },
  },
  methods: {
    serializeData(resp) {
      return resp.item;
    },
    getEvent() {
      const { id } = this.$route.params;
      const payload = {
        args: [id],
        params: {
          expand: 'address,area,options,highest_event,organization,organization_name,active_members_count,nominations',
        },
      };
      return this.$models.event.objects.show(payload);
    },
  },
};
</script>
